(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["facebookslider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  $('.review-carousel').slick({
    infinite: true,
     autoplay: true,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
      dots: true,
  arrows: true,
  appendArrows: '.review-carousel',
  appendDots: '.slick-dots-wrapper',
  prevArrow: '<button type="button" class="slick-prev custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0860/7127/9940/files/chevron-left-Black.svg?v=1754126627"/></button>',
  nextArrow: '<button type="button" class="slick-next custom-arrow"><img src="https://cdn.shopify.com/s/files/1/0860/7127/9940/files/chevron-right-Black.svg?v=1754126628"/></button>',
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2 }},
      { breakpoint: 768, settings: { slidesToShow: 1 }}
    ]
  });
  $('.review-carousel').show();

  document.querySelectorAll('.read-more').forEach(function (btn) {
    btn.addEventListener('click', function () {
      const textEl = this.previousElementSibling;
      textEl.classList.toggle('expanded');
      this.textContent = textEl.classList.contains('expanded') ? 'Read less' : 'Read more';
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
